/** Tour tooltip uses MUI Popper (portaled). Markup hooks must stay in sync in AppTour + Tempo outside-click. */
export const APP_TOUR_POPPER_CLASS = 'mf-app-tour-popper';
export const APP_TOUR_CHROME_ATTR = 'data-mf-app-tour-chrome';
